import { HTTP } from '@/services/axios';

export async function getTags({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Tag/getTagList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getTag({tagId}){
    let result = {};
  
    await HTTP({
        method: 'get',
        url: `/app/core/Tag/getTagData.php?tagId=${tagId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getTagOptions({searchName}){
    let result = {};
    var bodyFormData = new FormData();
    bodyFormData.set('searchName',searchName);
    
    await HTTP({
        method: 'get',
        url: '/app/core/Tag/getTagOptions.php',
        data: bodyFormData
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function unlockTag({tagId}){
    let result = {};

    var data = {'myRecordID':tagId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Tag/controlTagUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateTag({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state}
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Tag/controlTagChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createTag({data}){
    let result = {};
    
    await HTTP({
        method: 'post',
        url: '/app/core/Tag/controlTagSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveTag({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Tag/controlTagSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteTag({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Tag/controlTagDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}
